import { useState } from "react";
import { useNavigate } from "react-router-dom";

const quickTags = ["科幻", "悬疑", "高分剧集", "犯罪", "爱情"];

export default function HomeSearch() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const go = (value: string) => {
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
      <div className="-mt-8 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:-mt-10 md:flex-row md:items-center md:gap-6 md:p-5">
        <div className="flex items-center gap-2 md:w-56">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className="ri-compass-3-line text-xl"></i>
          </span>
          <div className="flex flex-col leading-tight">
            <span className="text-sm font-semibold text-foreground-950">影视资源检索</span>
            <span className="text-xs text-foreground-600">输入片名或题材关键词</span>
          </div>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            go(query);
          }}
          className="flex flex-1 flex-col gap-3 sm:flex-row"
        >
          <div className="flex h-11 flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="例如：星际、悬疑、英国剧集…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </div>
          <button
            type="submit"
            className="flex h-11 shrink-0 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-2-line"></i>
            立即搜索
          </button>
        </form>

        <div className="flex flex-wrap items-center gap-2">
          {quickTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => go(tag)}
              className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}